__turbopack_context__.v({
  "curtainExit": "easter-egg-module__fBKS-W__curtainExit",
  "curtainReveal": "easter-egg-module__fBKS-W__curtainReveal",
  "textExit": "easter-egg-module__fBKS-W__textExit",
  "textReveal": "easter-egg-module__fBKS-W__textReveal",
});
